import Vue from "vue";
import recommendedDriver from "./components/parametric-search/RecommendedDriver"
import contactForm from "./components/ContactForm.vue";

import store from "./store";

import ApiService from "./common/api.service";
import Vuelidate from "vuelidate";
import {VueReCaptcha} from "vue-recaptcha-v3";

import 'vue-search-select/dist/VueSearchSelect.css'
import {LOGOUT_USER} from "./store/actions.type";

ApiService.init();

const parametricSearchPublic = document.querySelector("#app");
if (parametricSearchPublic) {
    (async () => {
        const app = await import("./App");
        const router = await import("./router/parametric-router");
        return new Vue({
            router: router.default,
            store,
            render: h => h(app.default)
        }).$mount(parametricSearchPublic);
    })();
}


if (document.querySelector("#documentLibrary")) {
    (async () => {
        const app = await import("./App");
        const router = await import("./router/documents-router");
        new Vue({
            router: router.default,
            store,
            render: h => h(app.default)
        }).$mount("#documentLibrary");
    })();

}

const pipRecommendedDriver = document.querySelector("#recommendedDriverPage")
if (pipRecommendedDriver) {
    new Vue({
        el: document.querySelector("#recommendedDriverPage"),
        store,
        components: {
            "recommended-driver": recommendedDriver
        }
    });
}

const vacancyApplicationForm = document.querySelector("#vacancyApplicationForm")
if (vacancyApplicationForm) {
    // Vue.use(VueReCaptcha, {
    //     siteKey: siteKey,
    //     loaderOptions: {
    //         autoHideBadge: true,
    //         useRecaptchaNet: true
    //     }
    // });
    new Vue({
        el: document.querySelector("#vacancyApplicationForm"),
        store,
        components: {
            "contact-form": contactForm
        }
    });
}

let myAmpleonRouter = null;
if (document.querySelector("#myAmpleonApp")) {
    (async () => {
        const app = await import("./App");
        myAmpleonRouter = (await import("./router/my-ampleon-router")).default;
        Vue.use(Vuelidate);
        Vue.use(VueReCaptcha, {
            siteKey: siteKey,
            loaderOptions: {
                autoHideBadge: true,
                useRecaptchaNet: true
            }
        });

        new Vue({
            router: myAmpleonRouter,
            store,
            render: h => h(app.default)
        }).$mount("#myAmpleonApp");
    })();
}

export function authHandler(error = {}) {
    if (error.hasOwnProperty('response') && error.response.hasOwnProperty('status')) {
        if (myAmpleonRouter !== null && (error.response.status === 401 || error.response.status === 403)) {
            store.dispatch(LOGOUT_USER).then(() => myAmpleonRouter.push('/'));
        }
    }

    if (error.hasOwnProperty('response') && error.response.hasOwnProperty('status')) {
        if (error.response.status === 302 || error.response.status === 302) {
            return error.response;
        }
    }

    return error;
}

export function checkResponseStatus(response = {}) {
    if (response.hasOwnProperty('status') && response.hasOwnProperty('data')) {
        if (response.status === 200 && response.data.hasOwnProperty('success') && response.data.success === false) {
            throw new Error(`An error occurred while performing request: ${response.data.message}`);
        }
    }
    return response;
}
